import { render, staticRenderFns } from "./TicketsLeft.vue?vue&type=template&id=f05b89e2&scoped=true&"
import script from "./TicketsLeft.vue?vue&type=script&lang=js&"
export * from "./TicketsLeft.vue?vue&type=script&lang=js&"
import style0 from "./TicketsLeft.vue?vue&type=style&index=0&id=f05b89e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05b89e2",
  null
  
)

export default component.exports